import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { TEXT_FEATURE_KEY } from './keys';
import { textReducer } from './reducers/text.reducer';
import { TextEffects } from './effects/text.effects';

export const textStoreProviders = [provideState(TEXT_FEATURE_KEY, textReducer), provideEffects(TextEffects)];

export { TextFacade } from './facades/text.facade';
export { textCleanup } from './guards/cleanup.guard';
export { Text } from './models';
